import { render, staticRenderFns } from "./InvoiceViewer.vue?vue&type=template&id=04cf6fba&scoped=true&"
import script from "./InvoiceViewer.vue?vue&type=script&lang=js&"
export * from "./InvoiceViewer.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceViewer.vue?vue&type=style&index=0&id=04cf6fba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf6fba",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04cf6fba')) {
      api.createRecord('04cf6fba', component.options)
    } else {
      api.reload('04cf6fba', component.options)
    }
    module.hot.accept("./InvoiceViewer.vue?vue&type=template&id=04cf6fba&scoped=true&", function () {
      api.rerender('04cf6fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/viewer/InvoiceViewer.vue"
export default component.exports